import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AdminComponent} from './layouts/admin/admin.component';
import {AuthComponent} from './layouts/auth/auth.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { CampaignsComponent } from './components/campaigns/campaigns.component';
import { IntegrationsComponent } from './components/integrations/integrations.component';
import { FbIntegationsComponent } from './components/integrations/fb-integations/fb-integations.component';
import { PippedriveIntegrationsComponent} from './components/integrations/pippedrive-integrations/pippedrive-integrations.component';
import { AddPippedriveIntegrationsComponent} from './components/integrations/pippedrive-integrations/add-pippedrive-integrations/add-pippedrive-integrations.component';



const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadChildren: './dashboard/dashboard.module#DashboardModule'
      }, {
        path: 'profile',
        loadChildren: './components/profile/profile.module#ProfileModule'
      }, {
        path: 'campaigns',
        component: CampaignsComponent,
        data: {
          title: 'Campañas',
          status: false,
          breadcrumb: 'Campañas'
        }
      }, 
      {
        path: 'integrations',
        component: IntegrationsComponent,
        data: {
          title: 'Integrations',
          status: false,
          breadcrumb: 'integraciones'
        }
      }, 
      {
        path: 'integrations/fb',
        component: FbIntegationsComponent,
        data: {
          title: 'Facebook',
          status: false,
          breadcrumb: 'facebook'
        }
      }, 
      {
        path: 'integrations/pippedrive',
        component: PippedriveIntegrationsComponent,
        data: {
          title: 'Pippedrive',
          status: false,
          breadcrumb: 'Pippedrive'
        }
      }, 
      {
        path: 'integrations/pippedrive/new/:id',
        component: AddPippedriveIntegrationsComponent,
        data: {
          title: 'Añadir nuevo',
          status: false,
          breadcrumb: 'Nuevo'
        }
      },
      {
        path: 'users',
        loadChildren: './components/users/users.module#UsersModule'
      },
     
      {
        path: 'clients',
        loadChildren: './components/clients/clients.module#ClientsModule'
      }, 
      
      {
        path: 'campaign/:id',
        loadChildren: './components/detail/detail.module#CampaignDetailModule'
      },
      {
        path: 'form/:id',
        loadChildren: './components/forms/forms.module#FormsModule'
      },
      {
        path: 'users/sales',
        loadChildren: './components/users/users.module#UsersModule'
      }
      /*{
        path: 'user/edit',
        component: UserDetailComponent,
        data: {
          title: 'Editar usuario',
          status: false,
          breadcrumb: 'Editar usuario'
        }
      }*/
    ]
  },
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: 'auth',
        loadChildren: './auth/auth.module#AuthModule'
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'dashboard'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts